import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  UncontrolledTooltip,
} from 'reactstrap';

// alphabetized
import FollowupAllButton from './followup_all_button';
import FollowupAllModal from './followup_all_modal';
import vahoy from '../../javascript/vahoy';

function ReporterFollowupAll(props) {
  const {
    current_user: user,
    button_text: buttonText,
    button_class: buttonClass,
    display_icon: displayIcon,
    example_subject: subject,
    to,
  } = props;

  const [showPopup, setShowPopup] = useState(false);
  const [emailBody, setEmailBody] = useState('');

  const closeModal = (reload) => {
    setShowPopup(false);
    if (reload) {
      window.location.reload();
    }
  };

  const showModal = (message) => {
    setEmailBody(message);
    setShowPopup(true);
    vahoy.track('ReporterFollowup#showModal');
  };

  const renderFollowup = () => {
    const {
      id: userId,
      email,
      authentication_token: token,
      auth_level: authLevel,
    } = user;

    // Check if user is internal (admin) - they cannot use reply all
    const isInternalUser = authLevel && authLevel !== 'BasicUser';
    const isDisabled = isInternalUser;

    return (
      <>
        <span className="ps-1" id="reply-all-button-wrapper">
          <FollowupAllButton
            buttonText={buttonText}
            buttonClass={`${buttonClass}${isDisabled ? ' disabled' : ''}`}
            displayIcon={displayIcon}
            clickEvent={() => !isDisabled && showModal('')}
            disabled={isDisabled}
          />
        </span>
        {isDisabled && (
          <UncontrolledTooltip placement="top" target="reply-all-button-wrapper">
            Only reporters can reply to pitches (you are an admin).
          </UncontrolledTooltip>
        )}
        <FollowupAllModal
          userId={userId}
          email={email}
          token={token}
          toSguid={to}
          subject={subject}
          emailBody={emailBody}
          showPopup={showPopup}
          closeModal={closeModal}
        />
      </>
    );
  };

  return renderFollowup();
}

ReporterFollowupAll.propTypes = {
  current_user: PropTypes.instanceOf(Object).isRequired,
  button_text: PropTypes.string,
  button_class: PropTypes.string,
  display_icon: PropTypes.bool,
  example_subject: PropTypes.string,
  existing_conversation_path: PropTypes.string,
  num_messages_already_exchanged: PropTypes.number,
  to: PropTypes.array.isRequired,
};

ReporterFollowupAll.defaultProps = {
  display_icon: false,
  example_subject: undefined,
};

export default ReporterFollowupAll;
